import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_HELPLINES_INIT_ACTION,
  FETCH_HELPLINES_SUCCESS_ACTION,
  FETCH_HELPLINES_FAIL_ACTION,
  ADD_HELPLINE_INIT_ACTION,
  ADD_HELPLINE_SUCCESS_ACTION,
  ADD_HELPLINE_FAIL_ACTION,
  EDIT_HELPLINE_INIT_ACTION,
  EDIT_HELPLINE_SUCCESS_ACTION,
  EDIT_HELPLINE_FAIL_ACTION,
} from "./action";
//import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchHelplines(value) {
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/helpLine?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_HELPLINES_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_HELPLINES_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddHelpline(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      sprtNo: value.value.sprtNo,
      sprtEmail: value.value.sprtEmail,
      role: value.value.role,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/helpLine`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_HELPLINES_INIT_ACTION });
      yield put({
        type: ADD_HELPLINE_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Helpline added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_HELPLINE_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* EditHelpline(value) {
  try {
    const token = localStorage.getItem("token");
console.log("active " +value.value.isActive);
    const data = {
      sprtNo: value.value.sprtNo,
      sprtEmail: value.value.sprtEmail,
      role: value.value.role,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/helpLine/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_HELPLINES_INIT_ACTION });
      yield put({
        type: EDIT_HELPLINE_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Helpline updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_HELPLINE_FAIL_ACTION,
        error: err
      });
    }
  }
}



export function* HelplineActionWatcher() {
  yield takeEvery(FETCH_HELPLINES_INIT_ACTION, fetchHelplines);
  yield takeEvery(ADD_HELPLINE_INIT_ACTION, AddHelpline);
  yield takeEvery(EDIT_HELPLINE_INIT_ACTION, EditHelpline);
}
